import { Button, styled } from '@mui/material';

type ShouldForwardPropType = {
  fillStartIcon?: string;
  fillEndIcon?: string;
};
export const MuiCustomButton = styled(Button, {
  shouldForwardProp: (prop: string) => !['fillStartIcon', 'fillEndIcon'].includes(prop),
})<ShouldForwardPropType>(({ theme, fillEndIcon, fillStartIcon }) => ({
  ...(fillStartIcon && { '&.MuiButton-root': { svg: { path: { fill: fillStartIcon } } } }),
  ...(fillEndIcon && { '&.MuiButton-root': { svg: { path: { fill: fillEndIcon } } } }),

  '&.btn-without-label': {
    gap: '0px',
    '&.MuiButton-sizeLarge': {
      padding: '10px',
      minHeight: '40px',
      width: '40px',
      minWidth: '40px',
    },
    '&.MuiButton-sizeMedium': {
      padding: '8px',
      width: '36px',
      minWidth: '36px',
      minHeight: '36px',
    },
    '&.MuiButton-sizeSmall': {
      padding: '8px',
      width: '32px',
      minWidth: '32px',
      minHeight: '32px',
    },

    '& .MuiButton-startIcon': {
      marginRight: '0',
    },
  },

  '&.outline-social-button': {
    '&.MuiButton-root': {
      fontSize: '14px',
      padding: '12px 16px',
    },

    '&.MuiButton-outlinedSecondary': {
      border: `1px solid ${theme.palette.case.neutral.n200}`,
      color: theme.palette.case.neutral.n700,
      svg: { path: { fill: theme.palette.case.neutral.n600 } },
      '&:hover': {
        color: theme.palette.case.neutral.n700,
        backgroundColor: theme.palette.case.neutral.n75,
        svg: { path: { fill: theme.palette.case.neutral.n600 } },
      },
      '&:active': {
        color: theme.palette.case.neutral.n800,
        backgroundColor: theme.palette.case.neutral.n100,
        svg: { path: { fill: theme.palette.case.neutral.n600 } },
      },

      '&: disabled': {
        color: theme.palette.case.neutral.n400,
        backgroundColor: theme.palette.case.neutral.n75,
        svg: { path: { fill: theme.palette.case.neutral.n400 } },
      },
    },
  },
}));
